import {useIsFeatureActive} from '@aboutyou/feature-flags';

export const useIsUrgencyTriggersDisabled = () => {
  return useIsFeatureActive('disable_urgency_triggers').isActive;
};
